import React, { useEffect, useState } from 'react'
import { useCompany } from '../contexts/CompanyContext'
import './LoadingSpinner.css'

function LoadingSpinner () {
  // Safely get company data - useCompany might not be available in all contexts
  let logoUrl = null
  let features = {}
  let companyLoading = false
  
  try {
    const companyData = useCompany()
    logoUrl = companyData?.logoUrl || null
    features = companyData?.features || {}
    companyLoading = companyData?.loading || false
  } catch (error) {
    // CompanyContext not available (e.g., during login) - that's fine
    // Just use default values
  }

  const [logoLoaded, setLogoLoaded] = useState(false)
  const [logoError, setLogoError] = useState(false)
  const hasLogo = features?.logo && logoUrl

  // Reset states when logoUrl changes
  useEffect(() => {
    if (logoUrl) {
      setLogoLoaded(false)
      setLogoError(false)
    }
  }, [logoUrl])

  const handleLogoLoad = () => {
    setLogoLoaded(true)
  }

  const handleLogoError = (e) => {
    console.error('LoadingSpinner: Logo failed to load', logoUrl)
    setLogoError(true)
    e.target.style.display = 'none'
  }

  // Debug logging (can be removed later)
  useEffect(() => {
    console.log('LoadingSpinner: State check', {
      hasLogo,
      logoUrl,
      featuresLogo: features?.logo,
      logoLoaded,
      logoError,
      companyLoading
    })
  }, [hasLogo, logoUrl, features?.logo, logoLoaded, logoError, companyLoading])

  return (
    <div className='spinner-overlay'>
      <div className='spinner-content'>
        {hasLogo && !logoError && logoUrl && (
          <div className='spinner-logo-container'>
            <img
              src={logoUrl}
              alt='Company Logo'
              className='spinner-logo'
              onLoad={handleLogoLoad}
              onError={handleLogoError}
            />
          </div>
        )}
        <div className='spinner-circle'></div>
        <p className='spinner-text'>Laden...</p>
      </div>
    </div>
  )
}

export default LoadingSpinner
